<template>
    <div class="feedback-question-tree-item">
        <AppSelect
            :target-select="currentLevelSimplifiedSelect"
            :array="simplifiedArray"
            :place-holder="placeholder"
            :on-select-update="onSelectUpdate"
        />
    </div>
    <feedback-question-tree
        v-if="isChildrenExist"
        :tree-level="nextTreeLevel"
        :target-select="targetSelect"
        :question-list="children"
        :on-question-update="onQuestionUpdate"
    />
</template>

<script>
import AppSelect from '@/components/AppSelect'

export default {
    name: 'FeedbackQuestionTree',
    components: {
        AppSelect
    },
    props: {
        treeLevel: {
            type: Number,
            required: false,
            default: 0
        },
        targetSelect: {
            type: Object,
            required: true
        },
        questionList: {
            type: Array,
            required: true
        },
        onQuestionUpdate: {
            type: Function,
            required: true
        }
    },
    data: () => ({
        currentLevelSelect: {}
    }),
    computed: {
        isChildrenExist() {
            return this.children.length
        },
        children() {
            return this.currentLevelSelect.children ?? []
        },
        simplifiedArray() {
            return this.questionList.map(this.simplifyQuestion)
        },
        nextTreeLevel() {
            return this.treeLevel + 1
        },
        placeholder() {
            return this.treeLevel === 0 ? this.$t('feedback.mainSelect') : ''
        },
        currentLevelSimplifiedSelect() {
            return this.simplifyQuestion(this.currentLevelSelect)
        }
    },
    watch: {
        targetSelect(value) {
            this.processTarget(value)
        }
    },
    mounted() {
        if (typeof this.targetSelect.id !== 'undefined') this.processTarget(this.targetSelect)
    },
    methods: {
        simplifyQuestion(question) {
            if (!Object.keys(question).length) return question
            return {
                title: question.attributes.title,
                id: question.id
            }
        },
        onSelectUpdate(question) {
            const feedbackQuestion = this.questionList.find(fq => fq.id === question.id)
            if (typeof feedbackQuestion === 'undefined') throw 'tree :: feedback question not found'
            this.onQuestionUpdate(feedbackQuestion)
        },
        processTarget(target) {
            const findQuestionOnCurrentLevel = (list) => {
                return list.find(el => {
                    if (el.id === target.id) return true
                    if (el.children?.length) return findQuestionOnCurrentLevel(el.children)
                    else return false
                })
            }

            if (Object.keys(target).length) {
                const currentLevelSelect = findQuestionOnCurrentLevel(this.questionList)
                this.currentLevelSelect = currentLevelSelect ?? this.questionList[0]
                if (typeof currentLevelSelect === 'undefined') this.onQuestionUpdate(this.currentLevelSelect)
                return
            }

            this.currentLevelSelect = target
        }
    }
}
</script>